// Minimal pub/sub bus (no React, no context)

import type { ToastEvent } from "./types";

type Listener = (e: ToastEvent) => void;

const listeners = new Set<Listener>();

export function onToast(fn: Listener) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function emitToast(e: ToastEvent) {
  for (const fn of listeners) fn(e);
}
